import axios from './../../function/axiosInstance'
import extract from './../../function/extract'
import { BASE_URL } from '../config'
import customFetch from './../../function/customFetch'

const url = `${BASE_URL}/files`

export const fetchFile = async ({
  id,
  showThumbnail
}: {
  id: string
  showThumbnail?: boolean
}): Promise<ApiResponse> => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('authToken')}`
  }
  try {
    const response = await customFetch(
      showThumbnail ? `${url}/${id}/thumbnail` : `${url}/${id}`,
      {
        headers
      }
    )
    const result = await response.blob()
    if (response.ok) {
      return {
        status: 'ok',
        data: result,
        error: undefined
      }
    }
    const jsonResult = await response.json()
    throw new Error(jsonResult.description)
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error.message
    }
  }
}

export const fetchFileWordCount = async (file: File): Promise<ApiResponse> => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
    'Content-Type': 'application/octet-stream',
    'x-file-name': encodeURIComponent(file.name)
  }
  try {
    const response = await fetch(`${url}/word-count`, {
      method: 'POST',
      headers,
      body: file
    })
    const result = await response.json()
    if (response.ok) {
      return {
        status: 'ok',
        data: result,
        error: undefined
      }
    }
    throw new Error(result.description)
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error.message
    }
  }
}
//api call for downloading payment bill summary
export const exportPdf = async (billId: string): Promise<ApiResponse> => {
  try {
    const response = await axios(`/creator-bills/receipts/${billId}`, {
      responseType: 'blob',
      params: {
        accept: 'pdf'
      }
    })

    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
